import { inferSalePathKind } from "../opsDealTypes/saleTypeProviders.js";
import type { DriveDealFacts } from "./driveFolderRecipeModel.js";

function str(v: unknown): string {
  return typeof v === "string" ? v.trim() : "";
}

function salePathFromText(raw: string): DriveDealFacts["sale_path"] {
  if (!raw) return "";
  const kind = inferSalePathKind(raw, raw);
  if (kind === "rto" || kind === "finance" || kind === "cash") return kind;
  return "other";
}

export function driveDealFactsFromParts(args: {
  status?: string | null;
  readyToDeliver?: boolean | null;
  eventHint?: string | null;
  salePath?: string | null;
  saleTypeName?: string | null;
  cancelReason?: string | null;
  snapshot?: Record<string, unknown> | null;
}): DriveDealFacts {
  const hint = (args.eventHint ?? "").toLowerCase();
  const status = (args.status ?? "").toLowerCase();
  let lifecycle: DriveDealFacts["lifecycle"] = "pending";
  if (status === "archived" || status === "cancelled" || hint.includes("cancel")) lifecycle = "cancelled";
  else if (args.readyToDeliver === true || hint.includes("deliver")) lifecycle = "delivered";

  const snap = args.snapshot ?? {};
  const saleRaw =
    args.salePath ||
    args.saleTypeName ||
    str(snap.purchase_type) ||
    str(snap.payment_type) ||
    str(snap.sale_path);
  const sale_path = salePathFromText(saleRaw);

  const reasonRaw = (args.cancelReason ?? "").toLowerCase();
  let cancel_reason: DriveDealFacts["cancel_reason"] = "";
  if (lifecycle === "cancelled") {
    if (reasonRaw.includes("reject") || hint.includes("reject")) cancel_reason = "rto_rejected";
    else cancel_reason = "customer_cancelled";
  }

  return { lifecycle, sale_path, cancel_reason };
}

export const DRIVE_RECIPE_PREVIEW_FACTS: Array<{ id: string; label: string; facts: DriveDealFacts }> = [
  { id: "pending-cash", label: "Pending · Cash", facts: { lifecycle: "pending", sale_path: "cash", cancel_reason: "" } },
  {
    id: "delivered-rto",
    label: "Delivered · RTO",
    facts: { lifecycle: "delivered", sale_path: "rto", cancel_reason: "" },
  },
  {
    id: "cancelled-customer",
    label: "Cancelled · Customer",
    facts: { lifecycle: "cancelled", sale_path: "cash", cancel_reason: "customer_cancelled" },
  },
  {
    id: "cancelled-rto",
    label: "Cancelled · RTO rejected",
    facts: { lifecycle: "cancelled", sale_path: "rto", cancel_reason: "rto_rejected" },
  },
];
